module.exports = __webpack_public_path__ + "img/Greenbriar Station Concepts_Page_1.7e7da1f1.jpg";